import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import React from "react";
import Divider from "components/common/Divider";
import Grid from "components/common/Grid";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";

const DashboardRevenue = (props) => {
  const classes = useStyles();

  function kFormatter(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
      : Math.sign(num) * Math.abs(num);
  }
  // const select_option_amount = ["Amount recieved", "Pending amount"];

  return (
    <>
      <Card>
        {props.isLoadingdashboardrevenue ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              height: "35vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Text className={classes.graphheading}>Revenue</Text>

              <Box>
                <Stack direction="row" spacing={2}>
                  <Text className={classes.dateheading}>
                    {props?.data?.since} - {props?.data?.to}
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <Divider
              sx={{ marginTop: "15px", marginBottom: "15px" }}
              variant="middle"
            />

            <Grid container spacing={2}>
              <Grid item md={3}>
                <Box>
                  <Stack direction="row" spacing={2}>
                    <Text className={classes.totalheading}>
                      Total Revenue :
                    </Text>
                    <Text
                      sx={{
                        marginLeft: "8px!important",
                        marginTop: "2px!important",
                      }}
                      className={classes.valueheading}
                    >
                      ₹
                      {kFormatter(
                        props.data?.total_revenue[0]
                          ? props.data?.total_revenue
                          : ""
                      )}
                    </Text>
                  </Stack>
                </Box>
              </Grid>
              <Grid item md={7}>
                <Box>
                  <Stack direction="row" spacing={2}>
                    <Text className={classes.totalheading}>
                      Avg Revenue Per Customer :
                    </Text>
                    <Text
                      sx={{
                        marginLeft: "8px!important",
                        marginTop: "2px!important",
                      }}
                      className={classes.valueheading}
                    >
                      ₹
                      {kFormatter(
                        props?.data?.avg_revenue ? props?.data?.avg_revenue : ""
                      )}
                    </Text>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item md={12}>
                <Box className={classes.HighchartsFirst}>
                  <HighchartsReact
                    sx={{ width: "100%" }}
                    highcharts={Highcharts}
                    options={props !== null ? props.options : " "}
                  />
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        )}
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },

  graphheading: {
    fontSize: "15px",
    color: "#545454",
    letterSpacing: "0.09px",
    textTransform: "uppercase",
    font: "Nunito Sans",
    fontWeight: "bold",
  },

  dateheading: {
    fontSize: "14px",
    color: "#B4B4BE",
    font: "Nunito Sans",
  },

  totalheading: {
    fontSize: "12px",
    color: "#7E84A3",
    fontWeight: "600",
    font: "Nunito Sans",
  },

  valueheading: {
    fontSize: "12px",
    letterSpacing: "0.1px",
    color: "#545454",
    fontWeight: "600",
    font: "Nunito Sans",
  },
}));

export default DashboardRevenue;
